<!-- Section: Design Block -->
<section class="mb-10">


  <!-- Background image -->
  <div class="p-5 text-center bg-image" style="
                background-image: url('https://mdbcdn.b-cdn.net/img/new/slides/146.webp');
                height: 500px;
                ">
    <div class="mask" style="background-color: rgba(0, 0, 0, 0.7)">
      <div class="container">
        <div class="row gx-lg-5 align-items-center">
          <div class="col-lg-6 mb-5 mb-lg-0">
            <h1 style="color: rgb(177, 195, 221)" class="my-5 display-3 fw-bold ls-tight">
              The best place <br />
              <span class="text-primary">for your business</span>
            </h1>
            <!-- <p style="color: rgb(177, 195, 221)">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit.
                            Eveniet, itaque accusantium odio, soluta, corrupti aliquam
                            quibusdam tempora at cupiditate quis eum maiores libero
                            veritatis? Dicta facilis sint aliquid ipsum atque?
                        </p> -->
          </div>

          <!-- <div class="col-lg-6 mb-5 mb-lg-0">
                        <div class="card">
                            <div class="card-body py-5 px-md-5">
                                <app-registra-nuovo-utente></app-registra-nuovo-utente>
                            </div>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>
  </div>
</section>

<mdb-carousel [controls]="true" [indicators]="true" [animation]="'fade'">
  <mdb-carousel-item style="max-height: 500px;">
    <div class="bg-image">
      <img style="max-height: 500px;" src="../../../assets/stockMarket.jpg" class="d-block w-100" />
      <div class="mask" style="background-color: rgba(0, 0, 0, 0.4);"></div>
      <div class="carousel-caption d-none d-md-block">
        <h5>First slide label</h5>
        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        <button (click)="info('stockMF')" type="button" class="btn btn-primary btn-rounded">
          Informazioni
        </button>
      </div>
    </div>
  </mdb-carousel-item>
  <mdb-carousel-item style="max-height: 500px;">
    <img src="../../../assets/frattale.jpg" class="d-block w-100" />
    <div class="carousel-caption d-none d-md-block">
      <h5>Second slide label</h5>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
      <button (click)="info('frattale')" type="button" class="btn btn-primary btn-rounded">
        Informazioni
      </button>
    </div>
  </mdb-carousel-item>
  <mdb-carousel-item style="max-height: 500px;">
    <img style="max-height: 500px;" src="https://mdbootstrap.com/img/Photos/Slides/img%20(23).webp"
      class="d-block w-100" />
    <div class="carousel-caption d-none d-md-block">
      <h5>Third slide label</h5>
      <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
      <button type="button" class="btn btn-primary btn-rounded">
        Informazioni
      </button>
    </div>
  </mdb-carousel-item>
</mdb-carousel>
<!-- 
<app-dashboard *ngIf="isUtenteLogin"></app-dashboard> -->